﻿// jQuery plugin to move stuff around on the page.
(function ($) {
    $.fn.efw$moveme = function () {
        return this.each(function () {
            let $this = $(this),
                target = $this.attr('rel'),
                $target = $(target);

            if ($target.length > 0) {
                let pos = $target.offset();
                $this.css({
                    position: 'absolute',
                    left: (pos.left - $this.outerWidth() / 2) + 'px',
                    top: pos.top + 'px'
                }).show();
                //$this.detach();
                //$target.append($this);
            }
        });
    };

    // activate globally.
    $(document).ready(function () {
        $('.move-me').efw$moveme();
    });
})(jQuery);